<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Tabel Bantuan - View Only</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn color="grey" dark class="mb-2 mr-2" @click="backToBantuan" small>
                    <v-icon small>mdi-arrow-left</v-icon>
                    Back
                </v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col cols="2"><strong>Outlet</strong></v-col>
                    <v-col cols="2">
                        <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                        <span v-else>{{ outlet.code }} - {{ outlet.name }}</span>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col cols="2"><strong>Date</strong></v-col>
                    <v-col cols="2">
                        <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                        <span v-else>{{ date | moment }}</span>
                    </v-col>
                    <v-col cols="2"><strong>Variant Bottle / Volume</strong></v-col>
                    <v-col cols="2">
                        <v-skeleton-loader type="text" v-if="isLoadingOutlet" />
                        <span v-else>{{ bottle.description }}</span>
                    </v-col>
                </v-row>
                <section class="view">
                    <v-simple-table class="spreadsheet-tabel mb-0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="header-cell" colspan="5">
                                        Call Center : {{ callCenter }}
                                    </th>
                                    <th class="header-cell text-center">Sisa Closing</th>
                                    <th class="header-cell text-center text-no-wrap">Buffer <br/>(Min Stock Closing)</th>
                                    <th class="header-cell text-center">Selisih</th>
                                    <th class="header-cell" colspan="4"></th>
                                </tr>
                                <tr>
                                    <th class="header-cell" colspan="5">
                                        Koordinator : {{ koordinator }}
                                    </th>
                                    <td class="spreadsheet-cell text-center" style="width: 50px;">{{ sisaClosing }}</td>
                                    <td class="spreadsheet-cell text-center" style="width: 50px;">{{ minStockClosing }}</td>
                                    <th class="spreadsheet-cell text-center" style="width: 50px;"></th>
                                    <th class="header-cell" colspan="4"></th>
                                </tr>
                                <tr>
                                    <th class="header-cell" colspan="5">PPIC</th>
                                    <th class="header-cell text-center">{{ persenSisaClosing }}%</th>
                                    <th class="header-cell text-center">{{ persenMinStockClosing }}%</th>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell" colspan="4"></th>
                                </tr>
                            </thead>
                        </template>
                    </v-simple-table>
                    <v-simple-table class="spreadsheet-tabel" fixed-header height="440">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="header-cell text-center">No</th>
                                    <th class="header-cell text-center">Kode Produk</th>
                                    <th class="header-cell text-center">Nama Produk</th>
                                    <th class="header-cell text-center">Qty PO</th>
                                    <th class="header-cell text-center">Sisa Jam 3</th>
                                </tr>
                                <tr>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell text-center">Qty</th>
                                    <th class="header-cell text-center">Qty</th>
                                    <th class="header-cell text-center">Qty</th>
                                    <th class="header-cell text-center">Qty</th>
                                    <th class="header-cell text-center">Aktual Kirim</th>
                                    <th class="header-cell text-center">Adjustment</th>
                                    <th class="header-cell text-center">Setelah Adjustment</th>
                                    <th class="header-cell text-center">Nama Product Tester</th>
                                    <th class="header-cell text-center">Volume</th>
                                    <th class="header-cell text-center">Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, idx) in items" :key="idx">
                                    <td class="header-cell text-center">{{ idx + 1 }}</td>
                                    <td class="header-cell text-center">{{ row.product_code }}</td>
                                    <td class="header-cell text-left">{{ row.product_name }}</td>
                                    <td class="header-cell text-center">{{ calculateQtyPO(row) }}</td>
                                    <td class="header-cell text-center">{{ row.quantity_sisa_jam3 }}</td>
                                    <td class="header-cell text-center">{{ calculateSisaClosing(row) }}</td>
                                    <td class="header-cell text-center">{{ calculateBuffer(row) }}</td>
                                    <td class="header-cell text-center">{{ calculateSisaClosing(row) - calculateBuffer(row) }}</td>
                                    <td class="header-cell text-center">{{ calculateAktualKirimText(row) }}</td>
                                    <td class="header-cell text-center">{{ getQtyAdjustPO(row) }}</td>
                                    <td class="header-cell text-center">{{ calculateAfterAdjustment(row) }}</td>
                                    <td class="header-cell text-center">{{ row.product_name }}</td>
                                    <td class="header-cell text-center">{{ row.volume_tester }}</td>
                                    <td class="header-cell text-center">{{ row.quantity_tester }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th class="header-cell text-center" colspan="3">Total</th>
                                    <th class="header-cell text-center">{{ totalPPIC }}</th>
                                    <th class="header-cell text-center">{{ totalSisaJam3 }}</th>
                                    <th class="header-cell text-center">{{ totalSisaClosing }}</th>
                                    <th class="header-cell text-center">{{ totalBuffer }}</th>
                                    <th class="header-cell text-center"></th>
                                    <th class="header-cell text-center">{{ totalAktualKirim }}</th>
                                    <th class="header-cell text-center">{{ totalAdjustment }}</th>
                                    <th class="header-cell text-center">{{ totalAfterAdjustment }}</th>
                                    <th class="header-cell text-center" colspan="2"></th>
                                    <th class="header-cell text-center">{{ totalTester }}</th>
                                </tr>
                            </tfoot>
                        </template>
                    </v-simple-table>
                </section>
            </div>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            sisaClosing: 0,
            minStockClosing: 0,
            items: [],
            items_po: [],
            outlet: {},
            isLoading: false,
            isLoadingOutlet: false,
            date: null,
            bottle: {},
            botols: [],
            dayNumber: 0,
        }
    },

    computed: {
        totalPPIC() {
            return this.items_po.reduce((total, item) => total + Number(item.quantity_ordered), 0);
        },
        totalSisaJam3() {
            return this.items.reduce((total, item) => total + Number(item.quantity_sisa_jam3), 0);
        },
        totalSisaClosing() {
            return this.items.reduce((total, item) => total + this.calculateSisaClosing(item), 0);
        },
        totalBuffer() {
            return this.items.reduce((total, item) => total + this.calculateBuffer(item), 0);
        },
        totalAktualKirim() {
            return this.items.reduce((total, item) => total + this.calculateAktualKirim(item), 0);
        },
        totalAdjustment() {
            return this.items.reduce((total, item) => total + Number(this.getQtyAdjustPO(item)), 0);
        },
        totalAfterAdjustment() {
            return this.items.reduce((total, item) => total + Number(item.quantity_after_adjustment), 0);
        },
        totalTester() {
            return this.items.reduce((total, item) => total + Number(item.quantity_tester), 0);
        },
        persenSisaClosing() {
            if (this.totalSisaJam3 > 0) {
                return Math.round(this.sisaClosing / this.totalSisaJam3 * 100);
            } else {
                return 0;
            }
        },
        persenMinStockClosing() {
            if (this.totalPPIC > 0) {
                return Math.round(this.minStockClosing / this.totalPPIC * 100); 
            } else {
                return 0;
            }
        },
        callCenter() {
            if (this.outlet.call_center) {
                return this.outlet.call_center.name;
            } else {
                return '';
            }
        },
        koordinator() {
            switch (this.dayNumber) {
                case 0:
                    return this.outlet.coordinator_mon_name;
                case 1:
                    return this.outlet.coordinator_sun_name;
                case 2:
                    return this.outlet.coordinator_tue_name;
                case 3:
                    return this.outlet.coordinator_wed_name;
                case 4:
                    return this.outlet.coordinator_thu_name;
                case 5:
                    return this.outlet.coordinator_fri_name;
                case 6:
                    return this.outlet.coordinator_sat_name;
                default:
                    return '';
            }
        },
    },

    filters: {
        moment: function (date) {
            return moment(date).format('D MMMM YYYY');
        }
    },

    async created() {
        this.getBotols();
        this.date = this.$route.query.date || moment().format('YYYY-MM-DD');
        this.fetchOutlet();
    },

    methods: {
        getBotols() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.botols = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async fetchOutlet() {
            this.isLoadingOutlet = true;
            const outletCode = this.$route.params.code;

            try {
                const data = (await this.$store.dispatch('outlet/getObj', outletCode));
                this.outlet = data;
                
                const filteredBotols = this.outlet.botols.length === 0 
                    ? this.botols 
                    : this.botols.filter(item => this.outlet.botols.includes(item.code));
                
                const bottleCode = this.$route.query.bottle || filteredBotols[0]?.code;
                this.bottle = filteredBotols.find(b => b.code === bottleCode) || filteredBotols[0];

                this.fetchBantuan();
            } catch (error) {
                console.error('Error fetching outlet:', error);
            } finally {
                this.isLoadingOutlet = false;
            }
        },
        async fetchBantuan() {
            this.isLoading = true;
            const outletCode = this.$route.params.code;

            try {
                const data = (await this.$store.dispatch('bantuan/getData', {
                    outlet_code: outletCode,
                    size: this.bottle.code,
                    date: this.date,
                }));

                this.sisaClosing = data.sisa_closing;
                this.minStockClosing = data.min_stock_closing;
                this.items = data.items;
                this.items_po = data.items_po;
                this.dayNumber = data.day_number;
            } catch (error) {
                console.error('Error fetching detail planning:', error);
            } finally {
                this.isLoading = false;
            } 
        },
        calculateSisaClosing(item) {
            return Math.round(Number(item.quantity_sisa_jam3) * (this.persenSisaClosing / 100), 0);
        },
        calculateBuffer(item) {
            return Math.round(this.calculateQtyPO(item) * (this.persenMinStockClosing / 100), 0); 
        },
        calculateAktualKirim(item) {
            let result = this.calculateQtyPO(item) + this.calculateSisaClosing(item) + this.calculateBuffer(item);
            if (result > 0) {
                result = this.calculateQtyPO(item) - this.calculateSisaClosing(item) + this.calculateBuffer(item);
            }

            if (result < 0) {
                result = 0;
                return result;
            } else {
                if (result == 0) {
                    return 0;
                } else {
                    return result;
                }
            }
        },
        calculateAfterAdjustment(item) {
            const qtyAdj = Number(this.getQtyAdjustPO(item));
            const actualKirim = Number(this.calculateAktualKirim(item));
            return actualKirim + qtyAdj;
        },
        calculateAktualKirimText(item) {
            let result = this.calculateQtyPO(item) + this.calculateSisaClosing(item) + this.calculateBuffer(item);
            if (result > 0) {
                result = this.calculateQtyPO(item) - this.calculateSisaClosing(item) + this.calculateBuffer(item);
            }

            if (result < 0) {
                result = 0;
                return result;
            } else {
                if (result == 0) {
                    return '';
                } else {
                    return result;
                }
            }
        },
        calculateQtyPO(item) {
            let result = 0;
            const product = this.items_po.find((i) => i.product_code === item.product_code);
            if (product) {
                result = parseInt(product.quantity_ordered);
            }
            return result;
        },
        getQtyAdjustPO(item) {
            let result = 0;
            const product = this.items_po.find((i) => i.product_code === item.product_code);
            if (product) {
                result = parseInt(product.quantity_adjustment);
            }
            return result;
        },
        backToBantuan() {
            this.$router.push(`/tabel-bantuan`);
        }
    }
}
</script>

<style scoped>
.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
}

.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

.v-data-table table tfoot th {
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>
